/**
 * @generated SignedSource<<b252cdb06af339950d554d948fc8b91c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CryptoCurrencies = "BTC" | "ETH" | "LTC" | "USDC" | "%future added value";
export type BusinessRefundAddresInput = {
  BTC?: BusinessRefundAddressOptionInput | null;
  ETH?: BusinessRefundAddressOptionInput | null;
  LTC?: BusinessRefundAddressOptionInput | null;
  USDC?: BusinessRefundAddressOptionInput | null;
};
export type BusinessRefundAddressOptionInput = {
  address: string;
  amount: string;
  currency: CryptoCurrencies;
};
export type PaymentInformationRefundMutation$variables = {
  token: string;
  id: string;
  addresses: BusinessRefundAddresInput;
  otpCode?: string | null;
};
export type PaymentInformationRefundMutation$data = {
  readonly businessRefund: {
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type PaymentInformationRefundMutation = {
  variables: PaymentInformationRefundMutation$variables;
  response: PaymentInformationRefundMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addresses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otpCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "addresses",
        "variableName": "addresses"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "otpCode",
        "variableName": "otpCode"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessCharge",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentInformationRefundMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "BusinessRefundPayload",
        "kind": "LinkedField",
        "name": "businessRefund",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PaymentInformationRefundMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "BusinessRefundPayload",
        "kind": "LinkedField",
        "name": "businessRefund",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7dcb4c8a8be71973723fa8cf8050a969",
    "id": null,
    "metadata": {},
    "name": "PaymentInformationRefundMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentInformationRefundMutation(\n  $token: String!\n  $id: String!\n  $addresses: BusinessRefundAddresInput!\n  $otpCode: String\n) {\n  businessRefund(input: {token: $token, id: $id, addresses: $addresses, otpCode: $otpCode}) {\n    node {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3eeabcbcbd01b9911fd3e44eb8e9c0a1";

export default node;
